import React, { useEffect, useMemo } from "react";
import {
  BannerWrapper,
  Container,
  PialaByuImg,
  TitleImg,
} from "./Login.styled";

import { func } from "../../../utils";
import _function, { getStaticImg } from "../../../utils/function";
import useWindowSize from "../../../hooks/useWindowSize";
import { useNavigate, useParams } from "react-router-dom";
import LoginForm from "../../../components/molecules/v2/LoginForm/LoginForm";
import { useUserData } from "../../../store/user";
import { usePageContextFunction } from "../../../context/PageContext";
import Show from "../FormRegistration/components/Show";

const bannerMobile = getStaticImg("illustration/conference/banner-login-m.png");
const Login = () => {
  const { size } = useWindowSize();
  const navigate = useNavigate();
  const { accessToken } = useUserData();
  const { setIdInView } = usePageContextFunction();

  const isSmallScreen = (size?.height || 0) <= 667;
  const isExtraSmallScreen =
    (size?.width || 0) <= 375 && (size?.height || 0) <= 600;
  const isMobileView = (size?.width || 0) <= 830;

  useEffect(() => {
    setIdInView("slick-scroll");
    if (accessToken) navigate("/");
  }, [accessToken]);

  return (
    <BannerWrapper
      id="banner"
      backgroundImage={func.getStaticImg(
        isMobileView ? "bg/bg-plain-presscon.png" : "bg/banner-login-d.png",
      )}
      zIndex={2}
      position="relative"
      border={"1px transparent"}
      height={"100vh"}
    >
      <Show
        when={isMobileView}
        fallbackComponent={
          <React.Fragment>
            <div
              style={{
                margin: "auto",
                maxWidth: "1440px",
                display: "flex",
                gap: 160,
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <div>
                {/* <TitleImg
                  src={func.getStaticImg("illustration/conference/title-d.svg")}
                  alt="title"
                  maxWidth={"500px"}
                  display="flex"
                /> */}
                <PialaByuImg
                  //margin={"-10rem 0 0 0"}
                  src={func.getStaticImg("illustration/piala-byU-2026-d.png")}
                  maxWidth={589}
                  maxHeight={"589px"}
                  justifyContent={"center"}
                />
              </div>
              <div>
                <Container
                  justifyContent={"center"}
                  display={"flex"}
                  flexDirection="column"
                >
                  <Container justifyContent={"center"} display={"flex"}>
                    <LoginForm isMobileView />
                  </Container>
                </Container>
              </div>
            </div>
          </React.Fragment>
        }
      >
        <Container
          justifyContent={"center"}
          display={"flex"}
          flexDirection={"column"}
          style={{ overflow: "auto" }}
        >
          {/* <ImgBanner src={func.getStaticImg("bg/banner-kv.png")} alt="kv" /> */}
          {/* <TitleImg
            marginTop={
              isExtraSmallScreen ? "16px" : isSmallScreen ? "33px" : "40px"
            }
            src={func.getStaticImg("illustration/conference/title.svg")}
            alt="title"
            maxWidth={"260px"}
            scale={
              isSmallScreen || isExtraSmallScreen ? "scale(0.8)" : "scale(0.95)"
            }
          /> */}
        </Container>
        <Container display="inline">
          <Container
          // backgroundPosition={"0px -62px,0 19px,-20px -16px"}
          // backgroundImage={func.getStaticImg(
          //   "illustration/conference/shadow.svg"
          // )}
          //backgroundImage2={func.getStaticImg("bg/ribbon-banner.svg")}
          //  backgroundImage3={func.getStaticImg("bg/shine-bg.svg")}
          >
            <PialaByuImg
              margin={
                isExtraSmallScreen
                  ? "-100px auto -108px auto"
                  : isSmallScreen
                    ? "0px auto -60px auto"
                    : "0px auto -30px auto"
              }
              src={func.getStaticImg("illustration/piala-byU-2026-d.png")}
              scale={isExtraSmallScreen ? "scale(0.7)" : "scale(0.75)"}
              maxHeight={isMobileView ? "398px" : "425px"}
            />
          </Container>
        </Container>
        <Container justifyContent={"center"} display={"flex"}>
          <LoginForm isMobileView />
        </Container>
      </Show>
    </BannerWrapper>
  );
};

export default Login;
